import ApplicationModel, { attr } from '../ApplicationModel';
import { type AssistantActionButtonAttributes } from './generated/AssistantActionButtonAttributes';
import { model } from '../modelBuilder';

interface AssistantActionButton extends AssistantActionButtonAttributes {}

@model
class AssistantActionButton extends ApplicationModel {
  // Start auto-generated
  static typename: 'AssistantActionButton' = 'AssistantActionButton';
  get typename(): 'AssistantActionButton' {
    return 'AssistantActionButton';
  }

  static fields = {
    label: attr({ readable: true }),
  };
  // End auto-generated
}

export default AssistantActionButton;
